export default __webpack_public_path__ + "static/media/ico-enrere.da51d271.svg";